import type { FaireProductEntity } from "../../entity_types/product";

export const p_2jreu6da7s: FaireProductEntity = {
  token: "p_2jreu6da7s",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - LEOPARD",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/07e6b3abc5e7049799e09376b19baecc132b9b354e39279ecba2ea2744cdc87a.jpeg",
  galleryImageUrls: [],
  priceDollars: 18.5,
  description: "This bubble skirt from Girlie Girl Originals features a leopard pattern and a bubble silhouette. It pairs with a variety of tops for versatile styling and reflects the brand’s bold, fun aesthetic for women’s wardrobes.",
  tags: [],
  msrpDollars: 37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:31.254Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
